import { List, ListItemButton, ListItemIcon, ListItemText, Badge } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import InventoryIcon from '@mui/icons-material/Inventory';
import PersonIcon from '@mui/icons-material/Person';
// import PriceCheckIcon from '@mui/icons-material/PriceCheck';
// import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CategoryIcon from '@mui/icons-material/Category';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DashboardIcon from '@mui/icons-material/Dashboard';

const menuItems = [
    {
        label: 'Dashboard',
        icon: <DashboardIcon />,
        path: '/dashboard',
    },
    {
        label: 'Pedidos',
        icon: <ShoppingCartIcon />,
        path: '/dashboard/pedidos',
    },
    {
        label: 'Usuarios',
        icon: <PersonIcon />,
        path: '/dashboard/usuarios',
    },
    {
        label: 'Clientes',
        icon: <PeopleIcon />,
        path: '/dashboard/clientes',
    },
    {
        label: 'Vendedores',
        icon: <PeopleIcon />,
        path: '/dashboard/vendedores',
    },
    {
        label: 'Tipos de Cliente',
        icon: <CategoryIcon />,
        path: '/dashboard/tipos-cliente',
    },
    {
        label: 'Productos',
        icon: <InventoryIcon />,
        path: '/dashboard/productos',
    },
    // {
    //     label: 'Bloque de precios',
    //     icon: <AttachMoneyIcon />,
    //     path: '/dashboard/bloque-precios',
    // },
    // {
    //     label: 'Lista de precios',
    //     icon: <PriceCheckIcon />,
    //     path: '/dashboard/lista-precios',
    // },
    {
        label: 'Promociones',
        icon: <LocalOfferIcon />,
        path: '/dashboard/promociones',
    },
    {
        label: 'Banners Principal',
        icon: <UploadFileIcon />,
        path: '/dashboard/banners-principal',
    },
    {
        label: 'Banners Tienda',
        icon: <UploadFileIcon />,
        path: '/dashboard/banners-tienda',
    },
    {
        label: 'Categorias Principal',
        icon: <CategoryIcon />,
        path: '/dashboard/categorias-principal',
    },
    {
        label: 'Banners Secundarios',
        icon: <UploadFileIcon />,
        path: '/dashboard/banners-secundarios',
    },
    {
        label: 'Productos Destacados',
        icon: <UploadFileIcon />,
        path: '/dashboard/productos-destacados',
    },
];

function SidebarMenu() {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <List sx={{ mt: 1 }}>
            {menuItems.map((item) => {
                // const isActive = location.pathname.startsWith(item.path);
                const isActive = location.pathname === item.path;

                return (
                    <ListItemButton
                        key={item.label}
                        selected={isActive}
                        onClick={() => navigate(item.path)}
                        sx={{
                            borderRadius: 2,
                            mx: 1,
                            my: 0.5,
                            backgroundColor: isActive ? '#E6F4EA' : 'transparent',
                            border: isActive ? '2px solid #1976d2' : '2px solid transparent',
                            '&:hover': {
                                backgroundColor: isActive ? '#E6F4EA' : '#f5f5f5',
                            }
                        }}
                    >
                        <ListItemIcon sx={{ color: isActive ? '#1976d2' : 'inherit' }}>
                            {item.badge ? (
                                <Badge badgeContent={item.badge} color="error">
                                    {item.icon}
                                </Badge>
                            ) : (
                                item.icon
                            )}
                        </ListItemIcon>
                        <ListItemText
                            primary={item.label}
                            primaryTypographyProps={{
                                fontWeight: isActive ? 'bold' : 'normal',
                                color: isActive ? '#1976d2' : 'inherit',
                            }}
                        />
                    </ListItemButton>
                );
            })}
        </List>
    );
}

export default SidebarMenu;

